import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import WelcomeHeader from "../../../components/CustomerDashboard/WelcomeHeader/WelcomeHeader";
import CarbonSaving from "../../../components/CustomerDashboard/CarbonSavings/CarbonSaving.js";
import PrintActivity from "../../PrintActivity/PrintActivity.js";
import { useSelector } from "react-redux";
import {
    isBonusPagesAvailableInDiscountArray,
    IsDeviceEnrolledToEcoPro
} from "../../../constants/AppMethod.js";
import './Dashboard.css'
import BrotherPlusDashboard from "../BrotherPlus/Dashboard.js";
import useEcoProUpdateDeviceState from "../../../utils/CustomHooks/useEcoProUpdateDeviceState.js";
import { getLocalSessionData, getUserSessionData, setLocalSessionData } from "../../../utils/Authentication/handleUserSession.js";
import { DASHBOARD_REFRESH_INTERVAL, LOCALSESSIONDATAKEYS } from "../../../constants/AppConstants.js";
import useIntervalAsync from "../../../utils/CustomHooks/useIntervalAsync.js";
import EcoproDashboardAlert from "../../../components/CustomerDashboard/EcoPro/EcoproDashboardAlert/EcoproDashboardAlert.js";
import EcoproEnrolledDevice from "../../../components/CustomerDashboard/EcoPro/EcoproEnrolledDevice/EcoproEnrolledDevice.js";
import EcoproPlanUsageDetails from "../../../components/CustomerDashboard/EcoPro/EcoporPlanUsageDetails/EcoproPlanUsageDetails.js";
import EcoproOrderHistory from "../../../components/CustomerDashboard/EcoPro/EcoproOrderHistory/EcoproOrderHistory.js";
import EcoproChangeDevice from "../../../components/CustomerDashboard/EcoPro/EcoproChangeDevice/EcoproChangeDevice.js";
import { getFeatureSwitchByKey } from "../../../utils/Authentication/handleUserSession.js";
import { featureSwitchName } from "../../../constants/AppConstants.js";
import BonusPages from "../../../components/CustomerDashboard/EcoPro/BonusPages/BonusPages.js";
import EasyPayPlanModal from "../../../components/Web/Customer/BrotherPlus/EasyPayPlan/EasyPayPlanModal/EasyPayPlanModal.js";
import EasyPayPlanContent from "../../../components/Web/Customer/BrotherPlus/EasyPayPlan/Content/Content.js";
import sparkleIcon from "../../../assets/images/BrotherPlus/wand-magic-sparkles-icon.svg";
import { ENVSettings } from "../../../constants/ENVSettings.js";
import { SOURCE_MY_DEVICE } from "../../MyDevices/components/SuppliesComponent.js";

const EcoProDashboard = (props) => {
    const { source = null, selectedDeviceID = null, isBothEnrolledServices = false, deviceData, handleDeviceInfoDetails, handleDeviceStatusDetails, showBplusWidget } = props
    const { t } = useTranslation(["translation"]);
    const UID = getUserSessionData('UserId');
    const deviceId = (source === SOURCE_MY_DEVICE && selectedDeviceID)
        ? selectedDeviceID
        : getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [displayEasyPayPlanBannerBottom, handleEasyPayPlanBannerDisplayBottom] = useState(false);
    const brotherPlusEasyPayBannerRef = useRef(null);
    const enrollmentStatus = useSelector(state => state.EnrollmentStatus);
    const BrotherPlusRegistrationResult = useSelector(state => state.BROTHERPLUS.RegisterService);
    const isDeviceEnrolledToEcoPro = IsDeviceEnrolledToEcoPro();
    const IsBrotherPlusFeatureSwitchEnabled = getFeatureSwitchByKey(featureSwitchName.BROTHER_PLUS);
    const [deviceInfoResponse, setDeviceInfoResponse] = useState({
        success: false,
        loader: true,
        response: null,
        error: null
    });

    // below code snippet is to clear the previous state of 
    // GetDeviceInfo API when a new device is selected in MyDevices page
    useEffect(() => {
        if (source === SOURCE_MY_DEVICE && deviceInfoResponse.success &&
            (deviceInfoResponse?.response?.deviceId !== selectedDeviceID)) {
            setDeviceInfoResponse({
                success: false,
                loader: true,
                response: null,
                error: null
            });
        }
    }, [source, selectedDeviceID, deviceInfoResponse.success, deviceInfoResponse?.response?.deviceId]);

    const updateState = useEcoProUpdateDeviceState({ deviceId, userId: UID, setDeviceInfoResponse });
    useIntervalAsync(updateState, DASHBOARD_REFRESH_INTERVAL);

    useEffect(() => {
        const serialNumberLocalData = getLocalSessionData(LOCALSESSIONDATAKEYS.SERIAL_NUMBER)
        const modelLocalData = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_MODEL);
        const { serialNumber = null, model = null } = deviceInfoResponse?.response || {};
        if (serialNumber && !serialNumberLocalData) {
            setLocalSessionData(LOCALSESSIONDATAKEYS.SERIAL_NUMBER, serialNumber);
        }
        if (model && !modelLocalData) {
            setLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_MODEL, model);
        }

        // set device info data to send to parent callback functions
        if (handleDeviceInfoDetails) {
            handleDeviceInfoDetails(deviceInfoResponse);
        }
    }, [deviceInfoResponse, handleDeviceInfoDetails]);

    useEffect(() => {
        if (displayEasyPayPlanBannerBottom && brotherPlusEasyPayBannerRef.current) {
            brotherPlusEasyPayBannerRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [displayEasyPayPlanBannerBottom]);

    useEffect(() => {
        if (BrotherPlusRegistrationResult.success) {
            handleEasyPayPlanBannerDisplayBottom(false);
        }
        if (BrotherPlusRegistrationResult.error) {
            setIsModalOpen(false);
            handleEasyPayPlanBannerDisplayBottom(false);
        }
    }, [BrotherPlusRegistrationResult]);


    const onSkipBrotherPlusService = (val) => {
        handleEasyPayPlanBannerDisplayBottom(val);
    }
    /**
     * Method to validate to display the Brother plus banner to old users, those activated the subscription before March 01, 2025.
     * 
     * @returns boolean
     */
    const isUserEligibleForBrotherPlusEnrollment = () => {
        let isEligible = false;
        const subscriptionActivateDate = new Date(deviceInfoResponse?.response?.service?.activatedDate);
        const comparisonDate = new Date(ENVSettings.ELIGIBLE_DATE_FOR_ECOPRO_USER_TO_DISPLAY_BROTHER_PLUS_BANNER);
        if (subscriptionActivateDate && subscriptionActivateDate <= comparisonDate) {
            isEligible = true;
        }
        return isEligible;
    }
    const validateBrothePlusBannerDisplay = () => {
        let canDisplay = false;
        const isEligible = isUserEligibleForBrotherPlusEnrollment();
        if (
            IsBrotherPlusFeatureSwitchEnabled
            && !isBothEnrolledServices
            && isEligible
        ) {
            canDisplay = true;
        }
        return canDisplay
    }
    const handleBrotherPlusGetStartedBottomWidget = () => {
        setIsModalOpen(true);
    }

    return (
        <>
            {source === SOURCE_MY_DEVICE ?
                <>
                    {
                        <div className="ecopro-dashboard-wrapper">
                            <div className="ecopro-tile ecopro-tile-1">
                                <EcoproPlanUsageDetails deviceInfoResponse={deviceInfoResponse} />
                            </div>
                            <div className="ecopro-tile ecopro-tile-1">
                                <EcoproOrderHistory source={SOURCE_MY_DEVICE} />
                            </div>
                            <div className="ecopro-tile ecopro-tile-1 trends-avg-pages">
                                <PrintActivity
                                    showAvgPagesUsed={true}
                                    isChildComp={true}
                                    isBlockActive={true}
                                />
                            </div>
                            <div className="column-3-container">
                                {
                                    isDeviceEnrolledToEcoPro && deviceInfoResponse?.success && deviceInfoResponse?.response?.isSwapEligible ?
                                        <div className="ecopro-tile-7">
                                            <EcoproChangeDevice />
                                        </div> : null
                                }
                                <div className="ecopro-tile-7">
                                    <CarbonSaving isBlockActive={true} />
                                </div>
                                {
                                    (isBonusPagesAvailableInDiscountArray(deviceInfoResponse)) &&
                                    <div className="ecopro-tile-7">
                                        <BonusPages
                                            deviceInfoResponse={deviceInfoResponse}
                                            isBlockActive={true}
                                        />
                                    </div>
                                }
                                <div className="ecopro-tile-7">
                                    <PrintActivity
                                        showPagesUsed={true}
                                        isChildComp={true}
                                        isBlockActive={true}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {
                        (isBothEnrolledServices && showBplusWidget)
                            ? <BrotherPlusDashboard selectedDeviceID={deviceData?.deviceId} isBothEnrolledServices={isBothEnrolledServices && showBplusWidget} deviceData={deviceData} source={SOURCE_MY_DEVICE} handleDeviceStatusDetails={handleDeviceStatusDetails} />
                            : null
                    }
                </>
                :
                <>
                    <div>
                        <WelcomeHeader />
                        <EcoproDashboardAlert deviceInfoResponse={deviceInfoResponse} />
                        <div className="ecopro-dashboard-wrapper">
                            <div className="ecopro-tile ecopro-tile-1">
                                <EcoproEnrolledDevice deviceInfoResponse={deviceInfoResponse} />
                            </div>
                            <div className="ecopro-tile ecopro-tile-1">
                                <EcoproPlanUsageDetails deviceInfoResponse={deviceInfoResponse} />
                            </div>
                            <div className="ecopro-tile ecopro-tile-1">
                                <EcoproOrderHistory />
                            </div>
                            <div className="ecopro-tile ecopro-tile-1">
                                <PrintActivity showAvgPagesUsed={true} isChildComp={true} isBlockActive={enrollmentStatus.enrollment_completed} />
                            </div>
                            <div className="column-3-container">
                                {isDeviceEnrolledToEcoPro && deviceInfoResponse?.success && deviceInfoResponse?.response?.isSwapEligible ?
                                    <div className="ecopro-tile-7">
                                        <EcoproChangeDevice />
                                    </div> : null}
                                <div className="ecopro-tile-7">
                                    <CarbonSaving isBlockActive={enrollmentStatus.enrollment_completed} />
                                </div>
                                {(isBonusPagesAvailableInDiscountArray(deviceInfoResponse)) &&
                                    <div className="ecopro-tile-7">
                                        <BonusPages deviceInfoResponse={deviceInfoResponse} isBlockActive={enrollmentStatus.enrollment_completed} />
                                    </div>}
                                <div className="ecopro-tile-7">
                                    <PrintActivity showPagesUsed={true} isChildComp={true} isBlockActive={enrollmentStatus.enrollment_completed} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        (validateBrothePlusBannerDisplay())
                            ? <EasyPayPlanModal
                                isOpen={isModalOpen}
                                onClose={() => setIsModalOpen(false)}
                                onSkipService={onSkipBrotherPlusService}
                            />
                            : null
                    }
                    {
                        (validateBrothePlusBannerDisplay() && displayEasyPayPlanBannerBottom)
                            ?
                            <>
                                <div className="brotherplus-banner-divider-wrapper" ref={brotherPlusEasyPayBannerRef}>
                                    <img src={sparkleIcon} title="wand-magic-sparkle-icon" alt="wand-magic-sparkle-icon" />
                                    <p>{t("BROTHER_PLUS.EASY_PAY_BANNER.BANNER_DIVIDER_TXT")}</p>
                                </div>
                                <EasyPayPlanContent showSkip={false} handleGetStartedAsBottomWidget={handleBrotherPlusGetStartedBottomWidget} />
                            </>
                            : null
                    }
                    {
                        (isBothEnrolledServices && IsBrotherPlusFeatureSwitchEnabled)
                            ? <div className="mt-40">
                                <BrotherPlusDashboard isBothEnrolledServices deviceData={deviceData} />
                            </div>
                            : null
                    }
                </>
            }
        </>
    )
}

export default EcoProDashboard;